<template>
    <BModal :model-value="modal" scrollable centered title="Room Category" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Room Category</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormInput type="text" v-model="roomCategoryForm.name" placeholder="Name"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="number" v-model="roomCategoryForm.low_season_price" placeholder="Low Season Price"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="number" v-model="roomCategoryForm.high_season_price" placeholder="High Season Price"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="color" v-model="roomCategoryForm.color"></BFormInput>
            </div>
            <div class="form-group">
                <BFormTextarea type="text" v-model="roomCategoryForm.description" placeholder="Description"></BFormTextarea>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ roomCategoryData && roomCategoryData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BFormTextarea, BForm } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BFormTextarea,
        BForm
    },
    props: {
        modal: Boolean,
        roomCategoryData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const roomCategoryRepository = repositories ? repositories.roomCategory : null;

        const roomCategoryForm = ref({
            name: '',
            high_season_price: 0,
            low_season_price: 0,
            color: '',
            description: '',
        });

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.roomCategoryData.uuid ? update() : create()
        }

        const create = async () => {
            await roomCategoryRepository.create(roomCategoryForm.value).then(() => {
                updateModal(false)
                roomCategoryForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            console.log(roomCategoryForm.value)
            await roomCategoryRepository.update(roomCategoryForm.value, props.roomCategoryData.uuid).then(() => {
                updateModal(false)
                roomCategoryForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.roomCategoryData, (newData) => {
            if (newData) {
                roomCategoryForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            roomCategoryForm,
            updateModal,
            handleAction,
            create,
            update
        }
    }
}
</script>


